/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 *
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 *
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains a hook that proxies a hook from 
 * online-patient-management-reducers making less types required to use the hook.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/**
 * Required to make use of JSX functionality
 */
import * as React from 'react';

/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */

import * as Dtos from '../api/Neon.Dtos';
import { IRequestState, RequestState } from '@ngt/request-utilities';

/*
 * ---------------------------------------------------------------------------------
 * Constants
 * ---------------------------------------------------------------------------------
 */

export const DEFAULT_ACTION = (institutionId: number, form: any) => undefined;
export const DEFAULT_VALIDATION = { result: Dtos.ResultType.Valid, errors: [] };

export const DEFAULT_VALIDATION_LOAD_STATE = { state: RequestState.None };

/*
 * ---------------------------------------------------------------------------------
 * Functions
 * ---------------------------------------------------------------------------------
 */

const ValidationContext = React.createContext<Dtos.IValidationResult>(DEFAULT_VALIDATION);

export const ValidationLoadStateContext = React.createContext<IRequestState<Dtos.ResponseStatus>>(DEFAULT_VALIDATION_LOAD_STATE);

export const ValidateActionContext = React.createContext<typeof DEFAULT_ACTION>(DEFAULT_ACTION);

/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */

export default ValidationContext;
